import { types } from '../types/types';

const initialState = {
  guides: [],
  options: {
    enabled: true,
    isAdmin: false,
    max_mb: 20,
    role_keys: [],
    extensions: [],
    title_enabled: false,
    roles: [],
    modules: []
  },
  loading: false
};

export const specialistGuideReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SPECIALIST_GUIDE_SET_LOADING:
      return { ...state, loading: !!action.payload };
    case types.SPECIALIST_GUIDE_SET_OPTIONS:
      return { ...state, options: { ...state.options, ...(action.payload || {}) } };
    case types.SPECIALIST_GUIDE_SET_LIST:
      return { ...state, guides: action.payload || [], loading: false };
    default:
      return state;
  }
};
